import { ACCREDIBLE_MFA_SESSION_TOKEN_KEY } from '@accredible-frontend-v2/models';
import { AccredibleCookiesService } from '@accredible-frontend-v2/services/cookies';
import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  createUrlTreeFromSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Issuer should only be able to access MFA sign in screen if MFA session token is available.
 * Otherwise, should be redirected to the sign in.
 */
export const MfaSignInGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<UrlTree | boolean> => {
  const cookies = inject(AccredibleCookiesService);

  if (cookies.check(ACCREDIBLE_MFA_SESSION_TOKEN_KEY)) {
    return of(true);
  }

  return of(createUrlTreeFromSnapshot(route, ['']));
};
